import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AgenziaModel } from '../../crm/modules/settings/models/agenzia.model';
import { AuthModel } from '../models/auth.model';
import { LoginModel } from '../models/login.model';
import { UserModel } from '../models/user.model';
import { AuthStore } from './auth.store';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(private authStore: AuthStore, private router: Router, private http: HttpClient ) {
  }

  setAuth(auth: AuthModel): void {
    this.authStore.update({ auth });
  }

  setAgenzia(agenzia: AgenziaModel): void {
    this.authStore.update({ agenzia });
  }

  login(loginModel: LoginModel): Observable<any>{
    this.authStore.setLoading(true);
    return this.http.post<any>(`${environment.api.url}/api/v1/auth/login`, loginModel, {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      })
    }).pipe(
      tap((auth: AuthModel) => {
        this.authStore.setLoading(false);
        this.setAuth(auth);
        this.setAgenzia(auth.user!.agenzia)
      }),
      catchError((error, obs) => {
        this.authStore.setLoading(false);
        // throw next errors
        throw error;
      })
    );
  }

  logout(): void {
    this.authStore.reset();
    this.router.navigate(['/auth'], {
      queryParams: {},
    });
  }
}
